import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ProposalProject } from "../Model/ProposalProject";

export async function getProposalProject(id) {
    let response = await getAPIResponse("/v1/proposal-project/"+id);
    if (response === null) {
        return null;
    }
    let proposalProject = ProposalProject.createFromResponseData(response);
    return proposalProject;
}